
export class Paths {
  public static readonly LOGIN = '';

  public static readonly HOME = 'home';

  public static readonly PUBLIC_MAP = 'publicMap';

  public static readonly CUSTOMER_REGISTRY = 'customers';
  public static readonly CUSTOMER_USER_REGISTRY = 'customerUsers';
  public static readonly CUSTOMER_PRODUCT_ITEM_REGISTRY = 'customerProductItems';
  public static readonly E015_USER_REGISTRY = 'e015Users';
  public static readonly PRODUCT_TYPE_REGISTRY = 'productTypes';
  public static readonly CHARGERS_REGISTRY = 'chargers';

}
